import React, { Component } from "react";
import { Link } from "react-router-dom";
import request from "../../lib/requester";
import Autocomplete from "../../component/autocomplete";
import axios from "axios";
import _ from "lodash";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";

class Member extends Component {
  constructor(props) {
    super(props);
    this.state = {
      org_id: "",
      startDate: new Date(),
      endDate: new Date(),
      expDate: new Date(),
      principalName: "",
      programNumber: "",
      description: "",
      programType: "",
      budgetType: "",
      budget: 0,
      salesTarget: 0,
      programMember: "",
      totalParticipant: "",
      ref_number: "",
      error: [],
      lovProgramMember: [],
      lovBranch: [],
      suggestions: [],
      selectedBranch: [],
      lovDocument: [],
      fileContainer: [],
      lovPPH: [],
      value: "",
      memberId: "",
      memberType: "",
      branchId: "",
      autocomplete: "",
      participant: { customer_id: null, participant: null },
      showParticipant: true,
      showCabang: true,
      programId: "",
      success: "",
      productList: [{ productName: "", productId: "" }],
      documentList: [],
      notes: "",
      attachment: [],
      lovBudget: [],
      lovProgramType: [],
      docContainer: [],
      oriParticipant: "",
      org_initial: "",
      is_requested: false,
      is_active: "",
      status: "P",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submitteddate: "",
      pphType: "",
      pphRate: 0,
    };
  }

  componentDidMount = () => {
    this.setState({ programId: this.props.match.params.id });
    // this.getDocumentList()
    this.getProgramType();
    this.getProgramMember();
    this.getBranch();
    // this.getDetailProgram()
    this.getBudgetType();
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/program/detail-member";
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { header, docs, attachment, product, branch } = response.data.data;
        let branchContainer = branch.map((item, index) => {
          return item.branch_id;
        });

        let { participant } = this.state;
        participant.customer_id = header.customer_id;
        participant.participant = header.participant;
        this.setState({
          loading: false,
          description: header.description,
          startDate: new Date(header.start_date),
          endDate: new Date(header.end_date),
          expDate: new Date(header.claim_exp_date),
          programType: header.program_type_id,
          budgetType: header.budget_type_id,
          programMember: header.program_member_id,
          budget: header.budget.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          salesTarget: header.sales_target.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),

          totalParticipant: header.total_participant,
          pphType: header.pph_type,
          pphRate: header.pph_rate,
          notes: header.notes,
          docContainer: docs,
          is_update: header.status === "P" ? true : false,
          fileContainer: attachment,
          productList: product,
          ref_number: header.ref_number,
          programNumber: header.program_number,
          selectedBranch: branchContainer,
          oriParticipant: header.participant,
          org_initial: header.org_initial,
          is_requested: header.is_request_appr === "Y" ? true : false,
          is_active: header.is_active,
          status: header.status,
          principalName: header.org_name,
          org_id: header.org_id,
          submitteddate: moment(header.submitted_date).format("DD-MMM-YYYY"),
        });
        this.getDocumentList();
        this.handleChangeType(header.program_member_id);
        let app = this;
        window.setTimeout(() => {
          console.log(app.state);
        }, 200);
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getBudgetType = () => {
    let url = "/api/traces/v1/general/budget-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovBudget: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getProgramType = () => {
    let url = "/api/traces/v1/general/program-type?orgId=" + this.state.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramType: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getBranch = () => {
    let url = "/api/orafin/v1/participant/branch";
    request.getOracle(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getDocumentList = () => {
    let url = "/api/traces/v1/general/document-list?orgId=" + this.state.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovDocument: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.documentId) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  setChecked = (item) => {
    let find = _.find(this.state.docContainer, function (o) {
      return o.document_id === item.document_id;
    });
    return find ? true : false;
  };

  getProgramMember = () => {
    let url = "/api/traces/v1/general/member-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramMember: response.data.data });
        this.getDetailProgram();
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  renderLovProgramMember = () => {
    return (
      <select
        disabled
        className="form-control"
        name="programMember"
        onChange={this.handleChangeParticipant.bind(this)}
        value={this.state.programMember}
      >
        <option>- Select Participants -</option>
        {this.state.lovProgramMember.map((item, index) => (
          <option value={item.program_member_id} key={index}>
            {item.description}
          </option>
        ))}
      </select>
    );
  };

  handleChangeParticipant = (e) => {
    let value = e.target.value;
    this.handleChangeType(value);
  };

  handleChangeType = (value) => {
    let find = _.find(this.state.lovProgramMember, function (o) {
      return o.program_member_id === parseInt(value);
    });
    let type = find ? find.description : "";
    this.setState({ memberId: value, memberType: type });
    let { participant } = this.state;

    if (type === "Cabang") {
      participant.customer_id = null;
      participant.participant = null;
      this.setState({
        showParticipant: false,
        showCabang: true,
        participant,
        branchId: "",
      });
      // this.setState({ showParticipant: false, showCabang: false, participant, selectedBranch: ['0'], branchId: '' })
    } else if (type === "Nasional") {
      participant.customer_id = null;
      participant.participant = null;
      this.setState({
        showParticipant: false,
        showCabang: false,
        participant,
        selectedBranch: ["0"],
        branchId: "",
      });
    } else if (type === "Channel") {
      participant.customer_id = null;
      participant.participant = null;
      // this.setState({ showParticipant: false, showCabang: false, participant, selectedBranch: ['0'], branchId: '' })
      this.setState({
        showParticipant: true,
        showCabang: true,
        participant,
        branchId: "",
      });
    } else if (type === "Customer Group") {
      participant.customer_id = null;
      participant.participant = null;
      // this.setState({ showParticipant: false, showCabang: false, participant, selectedBranch: ['0'], branchId: '' })
      this.setState({
        showParticipant: true,
        showCabang: true,
        participant,
        branchId: "",
      });
    } else if (type === "Customer") {
      participant.customer_id = null;
      participant.participant = null;
      // this.setState({ showParticipant: false, showCabang: false, participant, selectedBranch: ['0'], branchId: '' })
      this.setState({
        showParticipant: true,
        showCabang: true,
        participant,
        branchId: "",
      });
    } else {
      this.setState({
        showParticipant: false,
        showCabang: true,
        participant,
        branchId: "",
      });
      let app = this;
      window.setTimeout(() => {
        app.setState({ showParticipant: true });
      }, 200);
    }
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ [name]: value });
  };

  renderBranch = () => {
    if (
      this.state.memberType === "Cabang" ||
      this.state.memberType === "Channel" ||
      this.state.memberType === "Customer Group"
    ) {
      return (
        <select
          multiple
          className="form-control select-multiple-height"
          name="branchId"
          value={this.state.selectedBranch}
          onChange={this.handleChangeMultiple.bind(this)}
        >
          {this.state.lovBranch.map((item, index) => (
            <option value={item.BRANCH_ID} key={index}>
              {item.BRANCH}
            </option>
          ))}
        </select>
      );
    } else if (this.state.memberType === "Customer") {
      return (
        <select
          className="form-control"
          name="branchId"
          value={this.state.selectedBranch[0]}
          onChange={this.handleChangeSingle.bind(this)}
        >
          {/* {this.state.lovBranch.map((item, index) => (
                        <option value={item.branch_id} key={index}>{item.branch}</option> */}
          {this.state.lovBranch.map((item, index) => (
            <option value={item.BRANCH_ID} key={index}>
              {item.BRANCH}
            </option>
          ))}
        </select>
      );
    } else {
      return (
        <select
          className="form-control"
          name="branchId"
          value={this.state.selectedBranch[0]}
          onChange={this.handleChangeSingle.bind(this)}
        >
          <option value="">- Select Branch -</option>
          {this.state.lovBranch.map((item, index) => (
            <option value={item.BRANCH_ID} key={index}>
              {item.BRANCH}
            </option>
          ))}
        </select>
      );
    }
  };

  handleChangeMultiple = (e) => {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ selectedBranch: value });
  };

  handleChangeSingle = (e) => {
    var value = e.target.value;
    this.setState({ selectedBranch: [value], branchId: value });
  };

  onSelectProduct = (suggestions, index) => {
    let participant = {};
    participant.customer_id =
      this.state.memberType === "Customer"
        ? suggestions.value
          ? suggestions.value
          : null
        : null;
    participant.participant = suggestions.text ? suggestions.text : null;
    this.setState({ participant: participant });
    console.log(participant);
  };

  get_token = () => {
    let token = window.localStorage.getItem("is_token");
    return token || "";
  };

  onChangeAutocomplete = (q) => {
    if (this.state.memberType === "Channel") {
      let param = {
        channel: q,
      };
      let container = [];
      return new Promise((resolve) => {
        request.postOracle("/api/orafin/v1/participant/channel", param, {
          success: function (response) {
            var api_response = response.data.data;
            container = api_response.map((item, index) => {
              item.text = item.CHANNEL;
              item.value = item.CHANNEL;
              return item;
            });
            resolve(container);
          },
          error: function (e) {
            resolve([]);
          },
        });
      });
    } else if (this.state.memberType === "Customer") {
      let param = {
        branch_id: this.state.selectedBranch[0],
        customer_name: q,
      };
      let container = [];
      return new Promise((resolve) => {
        request.postOracle("/api/orafin/v1/participant/customer", param, {
          success: function (response) {
            var api_response = response.data.data;
            container = api_response.map((item, index) => {
              item.text = item.CUSTOMER_NAME;
              item.value = item.CUSTOMER_ID;
              return item;
            });
            resolve(container);
          },
          error: function (e) {
            resolve([]);
          },
        });
      });
    } else if (this.state.memberType === "Customer Group") {
      let param = {
        customer_group: q,
      };
      let container = [];
      return new Promise((resolve) => {
        request.postOracle("/api/orafin/v1/participant/customer_group", param, {
          success: function (response) {
            var api_response = response.data.data;
            container = api_response.map((item, index) => {
              item.text = item.CUSTOMER_GROUP;
              item.value = item.CUSTOMER_GROUP;
              return item;
            });
            resolve(container);
          },
          error: function (e) {
            resolve([]);
          },
        });
      });
    }
  };

  renderParticipant = () => {
    if (this.state.showParticipant) {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Participant{" "}
              <span>
                <button
                  className="btn btn-sm btn-link"
                  onClick={this.handleEditParticipant.bind(this)}
                >
                  <i className="fas fa-edit"></i>
                </button>
              </span>
            </label>
            <div className="col-sm-8">
              <Autocomplete
                currentvalue={this.state.oriParticipant}
                onchange={this.onChangeAutocomplete.bind(this)}
                currentIndex={0}
                principalCode={this.state.user.org_initial}
                onselect={this.onSelectProduct.bind(this)}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  renderBranchContainer = () => {
    if (this.state.showCabang) {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Branch
            </label>
            <div className="col-sm-8">{this.renderBranch()}</div>
          </div>
        </div>
      );
    }
  };

  getPPHType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  validationForm = () => {
    let error = [];
    this.setState({ error: [] });

    if (this.state.memberType === "Cabang") {
      if (this.state.selectedBranch.length === 0) {
        error.push("Please select branch");
      }
    } else if (
      this.state.memberType === "Customer" ||
      this.state.memberType === "Channel" ||
      this.state.memberType === "Customer Group"
    ) {
      if (
        !this.state.participant.participant ||
        this.state.participant.participant.length === 0
      ) {
        error.push("Please select participant");
      }
      if (this.state.selectedBranch.length === 0) {
        error.push("Please select branch");
      }
    }

    if (error.length > 0) {
      this.setState({ error: error });
      window.scrollTo(0, 0);
      return false;
    } else {
      return true;
    }
  };
  handleSubmit = () => {
    if (this.validationForm()) {
      let url = "/api/traces/v1/program/insert-member";
      let param = {
        member_type: this.state.memberId,
        branch: this.state.selectedBranch,
        total_participant: this.state.totalParticipant,
        participant: this.state.participant,
        program_id: this.state.programId,
      };

      this.setState({ loading: true });
      request.postTraces(url, param, {
        success: function (response) {
          let { message } = response.data;
          this.setState({ loading: false, success: message });
          window.scrollTo(0, 0);
          let app = this;
          window.setTimeout(() => {
            app.props.history.push("/admin/member");
          }, 2000);
        }.bind(this),
        error: function (e) {
          this.setState({ loading: false });
        }.bind(this),
      });
      return false;
    }
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  renderDocument = () => {
    return this.state.lovDocument.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            disabled
            className="form-check-input"
            defaultChecked={this.setChecked(item)}
            type="checkbox"
            value={item.document_id}
            onClick={this.handleClickDocument.bind(this)}
            id="defaultCheck1"
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {item.document_name}
          </label>
        </div>
      </div>
    ));
  };

  renderProductList = () => {
    return (
      <table className="table table-striped table-sm table-bordered">
        <tr className="table-primary">
          <th>Product Description</th>
          <th>Product Reff</th>
          <th>Product Budget</th>
        </tr>
        {this.state.productList.map((item, index) => (
          <tr>
            <td>{item.item_description}</td>
            <td>{item.item_reff}</td>
            <td>{item.item_budget}</td>
          </tr>
        ))}
      </table>
    );
  };

  renderAttachment = () => {
    if (this.state.fileContainer && this.state.fileContainer.path) {
      return (
        <div className="col-md-6">
          Files:
          <br />
          <Link
            href=""
            onClick={this.handleRedirect.bind(this)}
            target="_blank"
          >
            {this.state.fileContainer.filename}
          </Link>
        </div>
      );
    }
  };

  // renderAttachment = () => {
  //     if (this.state.fileContainer && this.state.fileContainer.fullurl) {
  //         return (
  //             <div className="col-md-6">
  //                 Files:<br />
  //                 <Link to={{ pathname: this.state.fileContainer.fullurl }} target="_blank">{this.state.fileContainer.filename}</Link>
  //             </div>
  //         )
  //     }
  // }

  renderLovBudget = () => {
    return (
      <select
        className="form-control"
        disabled
        name="budgetType"
        value={this.state.budgetType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Budget -</option>
        {this.state.lovBudget.map((item, index) => (
          <option value={item.budget_type_id} key={index}>
            {item.budget_type}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgram = () => {
    return (
      <select
        className="form-control"
        disabled
        name="programType"
        value={this.state.programType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Program -</option>
        {this.state.lovProgramType.map((item, index) => (
          <option value={item.prog_type_id} key={index}>
            {item.program_name}
          </option>
        ))}
      </select>
    );
  };

  handleEditParticipant = () => {
    this.setState({ showParticipant: false });
    let app = this;
    window.setTimeout(() => {
      app.setState({ showParticipant: true, oriParticipant: "" });
    }, 200);
  };

  handleCancel = () => {
    this.props.history.push("/admin/member");
  };

  handleSubmitApproval = () => {
    if (this.validationForm()) {
      let url = "/api/traces/v1/program/insert-member";
      let param = {
        member_type: this.state.memberId,
        branch: this.state.selectedBranch,
        total_participant: this.state.totalParticipant,
        participant: this.state.participant,
        program_id: this.state.programId,
        user_name: this.state.user.username,
        source: "arman",
        menu: "program",
        function: "validation",
      };

      this.setState({ loading: true });
      request.postTraces(url, param, {
        success: function (response) {
          this.callBitrix();
        }.bind(this),
        error: function (e) {
          this.setState({ loading: false });
        }.bind(this),
      });
      return false;
    }
  };

  callBitrix = () => {
    if (this.validationForm()) {
      // pasang validasi submit
      let url = "/arman/v1/general/get-approver";
      let { id } = this.props.match.params;
      let param = {
        principal_code: this.state.org_initial,
        program_id: id,
      };
      this.setState({ loading: true });
      request.postArman(url, param, {
        success: function (response) {
          let approver = response.data.data.map((item, index) => {
            return item.uid;
          });
          let url_approval = "/api/traces/v1/program/validate-program";
          let param = {
            program_id: id,
            approver: approver,
            member_type: this.state.memberId,
            branch: this.state.selectedBranch,
            total_participant: this.state.totalParticipant,
            participant: this.state.participant,
            user_name: this.state.user.username,
            source: "arman",
            menu: "program",
            function: "validation",
          };
          request.postTraces(url_approval, param, {
            success: function (response) {
              this.setState({
                loading: false,
                success: "Approval has been submitted",
              });
              window.scrollTo(0, 0);
              let app = this;
              window.setTimeout(() => {
                app.props.history.push("/admin/member");
              }, 3000);
            }.bind(this),
            error: function (e) {
              this.setState({
                loading: false,
                error: ["Failed submit approval"],
              });
              window.scrollTo(0, 0);
            }.bind(this),
          });
        }.bind(this),
        error: function (e) {
          this.setState({ loading: false });
        }.bind(this),
      });
    }
  };

  handleReject = () => {
    let url = "/api/traces/v1/program/validation-reject";
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
      status: "R",
      notes: this.state.notes,
      user_name: this.state.user.username,
      source: "arman",
      menu: "program",
      function: "validation-Reject",
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { message } = response.data;
        window.scrollTo(0, 0);
        this.setState({ loading: false, success: message });
        let app = this;
        window.setTimeout(() => {
          app.props.history.push("/admin/member");
        }, 2000);
      }.bind(this),
      error: function (e) {
        window.scrollTo(0, 0);
        let error = e.response
          ? e.response.data.message
          : "Failed to reject program";
        this.setState({ loading: false, error: [error] });
      }.bind(this),
    });
  };

  renderButton = () => {
    if (!this.state.is_requested && this.state.status === "A") {
      return (
        <span>
          <button
            type="button"
            className="btn btn-info"
            onClick={this.callBitrix.bind(this)}
          >
            <i class="fas fa-users"></i> Submit Approval
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-danger"
            onClick={this.handleReject.bind(this)}
          >
            <i class="fas fa-times"></i> Reject
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-warning"
            onClick={this.handleCancel.bind(this)}
          >
            <i class="fas fa-arrow-left"></i> Back
          </button>
        </span>
      );
    } else {
      return (
        <span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={this.handleReject.bind(this)}
          >
            <i class="fas fa-times"></i> Reject
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-warning"
            onClick={this.handleCancel.bind(this)}
          >
            <i class="fas fa-arrow-left"></i> Back
          </button>
        </span>
      );
    }
  };

  renderLovPPh = () => {
    return (
      <select
        disabled
        className="form-control"
        name="pphType"
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  renderStatusApproval = () => {
    if (this.state.is_requested && this.state.is_active === "N") {
      return (
        <span>
          <div className="alert alert-warning">
            <i className="fas fa-exclamation-triangle"></i> Waiting Approval.
          </div>
        </span>
      );
    } else if (this.state.is_requested && this.state.is_active === "Y") {
      return (
        <span>
          <div className="alert alert-info">
            <i className="fas fa-check"></i> This program has been approved.
          </div>
        </span>
      );
    }
  };

    handleRedirect = (e) => {
    const url = request.getFileS3('principal-doc', this.state.fileContainer.filename);
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            {/* <Wizzard currentStep="member" /> */}
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showError()}
                    {this.showSuccess()}
                    {this.renderStatusApproval()}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Number
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programNumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Principal
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.principalName}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Reff Number / SKP
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                placeholder="Reference Number"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ref_number}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovProgram()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Descriptions
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="description"
                                placeholder="Description"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.description}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Budget Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovBudget()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Submitted Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.submitteddate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Start Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.startDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleStartDate}
                                disabled
                              />
                            </div>
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-2 col-form-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.endDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleEndDate}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Claim Exp Date
                            </label>
                            <div className="col-sm-8">
                              <DatePicker
                                selected={this.state.expDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleExpDate}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.budget}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Sales Target
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Sales Target"
                                name="salesTarget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.salesTarget}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphType"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              PPh Rate (%)
                            </label>
                            <div className="col-sm-4">
                              <input
                                disabled
                                type="number"
                                max="100"
                                min="0"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphRate"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Claim Documents</h5>
                          <div className="row">{this.renderDocument()}</div>
                        </div>
                      </div>
                      <hr />
                      <h5>Participants</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Participant type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovProgramMember()}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Total Participant
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="number"
                                disabled
                                name="totalParticipant"
                                className="form form-control"
                                value={this.state.totalParticipant}
                                onChange={this.handleChangeInput.bind(this)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {this.renderBranchContainer()}
                        {this.renderParticipant()}
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <h5>Products</h5>
                          {this.renderProductList()}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Notes
                            </label>
                            <div className="col-sm-8">
                              <textarea
                                cols="10"
                                // disabled
                                rows="5"
                                className="form-control"
                                name="notes"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.notes}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        {this.renderAttachment()}
                      </div>
                      <div className="row">
                        <div className="col-md-6">{this.renderButton()}</div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Member;
